import { render } from "./LancarMateriaPrimaEtapaProducao.vue?vue&type=template&id=70f1b820&scoped=true&ts=true"
import script from "./LancarMateriaPrimaEtapaProducao.vue?vue&type=script&lang=ts"
export * from "./LancarMateriaPrimaEtapaProducao.vue?vue&type=script&lang=ts"

import "./LancarMateriaPrimaEtapaProducao.vue?vue&type=style&index=0&id=70f1b820&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f1b820"]])

export default __exports__